<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-pen', fontSet: 'fad'}"
	[headerText]="data.title || ('GENERAL_TXT_SELECT_LANGUAGE' | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="language-selection-content">
			@if (data.description) {
				<p class="dialog-description">
					{{ data.description | translate }}
				</p>
			}

			<mat-form-field appearance="outline" class="language-select-field">
				<mat-label>{{ "GENERAL_TXT_SELECT_LANGUAGE" | translate }}</mat-label>
				<mat-select [(value)]="selectedLanguage" (selectionChange)="onLanguageChange($event)">
					@for (language of availableLanguages; track language) {
						<mat-option [value]="language.code">
							<div class="language-option">
								<span class="language-name">{{ language.name }}</span>
							</div>
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel', language: selectedLanguage})"
			[color]="'warn'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="data.cancelText.toUpperCase()"
		/>

		<sim-button
			(onClick)="close({action: 'ok', language: selectedLanguage})"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText.toUpperCase()"
		/>
	</ng-container>
</sim-basic-material-dialog>
